import React, { Component } from 'react';
import styleable from 'react-styleable';
import PropTypes from 'prop-types';
import { injectIntl, intlShape } from 'react-intl';
import filter from 'lodash/filter';
import forEach from 'lodash/forEach';
import messages from './messages';
import css from './index.scss';
import Button from '../button/index';
import Badge from '../badge/index';
import CourseBadge from '../course-badge/index';
import NewCourseLabel from '../new-course-label/index';
import AssignCourses from '../../containers/assign-courses-upf/index';
import Modal from '../modal/index';
import TaskCarryForward from './task-carry-forward/task-carry-forward';
import ConfirmationMessage from '../confirmation-message/index';
import { Warning } from '../../helpers/icon-dictionary';
import PortalCommunication from '../../portal-comms';
import Confirmation from '../confirmation/index';
import * as actionTypes from '../../containers/manage-assigned-courses/action-types';
import productEnum from '../../helpers/product-enum';
import { DEFAULT_COURSE_ID, DEFAULT_NEW_COURSE_ID } from '../../constants';
import { newCoursesAvailable } from '../../helpers/utils';

class assignCourseMapper extends Component {
    constructor(props) {
        super(props);
        const { defaultData, classrooms } = props;
        this.activeColor = '#32a8a7';
        this.defaultColor = '#fff';
        this.classrooms = classrooms;
        this.isAssignEvent = false;
        this.disableSave = true;
        this.disableAssignToGroup = true;
        this.showCancelConfirmation = false;
        this.isMathletics = props.selectedProduct.id === productEnum.MATHLETICS.id;
        this.state = {
            selectedYearGroup: defaultData.DefaultYear,
            selectedClassroom: defaultData.DefaultClassroom,
            selectedGroup: defaultData.DefaultGroup,
            groupCourse: {},
            selectedCourse: {
                id: DEFAULT_COURSE_ID,
                name: '',
                legacy: !this.isMathletics,
                newCourse: false,
                UPF: false
            },
            isUpdated: true,
            UPFSelected: false,
            LegacySelected: true,
            NewCoursesSelected: false
        };
    }

    componentWillReceiveProps(nextProps) {
        const { isAssignEvent } = nextProps;
        if (isAssignEvent) {
            this.props.dispatch({ type: actionTypes.CANCEL_ASSIGN_REQUEST });
        }
    }

    handleOnCourseSelection = (course, disableAssignToGroup = false) => {
        this.disableAssignToGroup = disableAssignToGroup;
        this.setState({
            selectedCourse: {
                ...course,
                legacy: this.state.LegacySelected,
                newCourse: this.state.NewCoursesSelected,
                UPF: this.state.UPFSelected
            }
        });
    }

    checkForClasses = (year) => {
        const { classrooms } = this.props;
        return !classrooms.find(item => item.yearGroupEnum === year);
    }

    updateClassroomId = (year) => {
        const { classrooms } = this.props;
        const classroom = classrooms.find(item => item.yearGroupEnum === year);
        this.setState({ selectedClassroom: classroom.classroomId });
        this.updateClassroomGroupId(classroom.classroomId);
    }

    updateClassroomGroupId = (classId) => {
        const { classrooms } = this.props;
        const classroom = classrooms.find(item => item.classroomId === classId);
        const group = classroom.classroomGroups[0];
        this.setState({ selectedGroup: group.id });
    }

    renderYears = () => {
        let yearRows = null;
        let index = 0;
        const { yearGroups } = this.props;
        if (yearGroups) {
            yearRows = yearGroups.map((val) => {
                index += 1;
                const rowStyle = this.checkForClasses(val.yearGroupEnum) ? `${css.disabled}` : `${css.selectable}`;
                return (
                    <div
                        className={rowStyle}
                        key={index}
                        onClick={() => this.updateState('year', val.yearGroupEnum)}
                        role="button"
                        tabIndex={0}>
                        <CourseBadge
                            background={val.yearGroupEnum === this.state.selectedYearGroup ?
                                this.activeColor : this.defaultColor}>
                            <Badge
                                badgeStyle={`${css.yearGroup} yg${val.yearGroupEnum}`}
                                content={val.shortName} />
                        </CourseBadge>
                    </div>
                );
            });
        }

        return yearRows;
    }

    renderYearClassrooms = () => {
        const { classrooms, defaultData } = this.props;
        let classroomRows = null;
        let index = 0;
        if (classrooms) {
            const year = this.state.selectedYearGroup !== -1 ? this.state.selectedYearGroup : defaultData.DefaultYear;
            const filteredClassrooms = filter(classrooms, (val) => {
                if (val.yearGroupEnum === year) {
                    return true;
                }
                return false;
            });
            classroomRows = filteredClassrooms.map((val) => {
                index += 1;
                return (
                    <div
                        className={css.infoContainer}
                        key={index}
                        onClick={() => this.updateState('class', val.classroomId)}
                        role="button"
                        tabIndex={0}>
                        <CourseBadge
                            background={val.classroomId === this.state.selectedClassroom ? this.activeColor
                                : this.defaultColor}>
                            <div className={
                                val.classroomId === this.state.selectedClassroom ? `${css.info} ${css.active}`
                                    : `${css.info}`
                            }>{val.name}</div>
                        </CourseBadge>
                    </div>
                );
            });
        }

        return classroomRows;
    }

    renderGroups = () => {
        const { classrooms } = this.props;
        let groupRows = null;
        let index = 0;
        if (classrooms) {
            groupRows = this.getFilteredClassroom(classrooms).classroomGroups.map((val) => {
                index += 1;
                return (
                    <div
                        className={css.infoContainer}
                        key={index}
                        onClick={() => this.updateState('group', val.id)}
                        role="button"
                        tabIndex={0}>
                        <CourseBadge
                            background={val.id === this.state.selectedGroup ? this.activeColor :
                                this.defaultColor}>
                            <div className={
                                val.id === this.state.selectedGroup ? `${css.info} ${css.active}`
                                    : `${css.info}`
                            }>{val.name}</div>
                        </CourseBadge>
                    </div>
                );
            });
        }

        return groupRows;
    }

    getUPFTitle = (group) => {
        if (group && group.upfCourseId > 0) {
            return group.upfCourseTitle;
        }

        return this.props.intl.formatMessage(messages.noCourseFound);
    }

    renderCourses = () => {
        const classroomList = this.classrooms;
        let group = null;
        if (this.classrooms) {
            const filteredClassroom = this.getFilteredClassroom(classroomList);
            if (this.state.selectedGroup !== -1) {
                group = this.getSelectedGroupInfo(filteredClassroom);
            }
            const showCancel = !!group.newCourseId;
            let courseName = '';
            if (this.state.LegacySelected) {
                courseName = group.newCourseId ? group.newCourseTitle : group.courseTitle;
            } else if (this.state.UPFSelected) {
                courseName = this.getUPFTitle(group);
            } else if (this.state.NewCoursesSelected) {
                courseName = group.conquestCourseTitle;
            }

            const viewCourseId = group.newCourseId || group.courseId;

            return (
                <div>
                    <NewCourseLabel
                        handleOnView={() => this.props.dispatch({ type: actionTypes.SHOW_COURSE_DETAILS, courseId: viewCourseId })}
                        hideButton={!this.state.LegacySelected}
                        label={courseName}
                        showCancel={showCancel}
                    />
                </div>
            );
        }

        return null;
    }

    addRemoveNewCourse = (isAdd, assignedTasksIds, carryForward) => {
        const clonedClassrooms = this.classrooms;
        const { selectedCourse } = this.state;
        const classroom = this.getFilteredClassroom(clonedClassrooms);
        const group = this.getSelectedGroupInfo(classroom);

        if (this.state.LegacySelected) {
            group.newCourseTitle = isAdd ? selectedCourse.name : '';
            group.newCourseId = isAdd ? selectedCourse.id : 0;
            group.isOptedOut = false;
        } else if (this.state.UPFSelected) {
            group.upfCourseTitle = isAdd ? selectedCourse.name : '';
            group.upfCourseId = isAdd ? selectedCourse.id : 0;
            group.isOptedOut = selectedCourse.id === 0;
        } else {
            group.conquestCourseTitle = isAdd ? selectedCourse.name : '';
            group.conquestCourseId = isAdd ? selectedCourse.id : DEFAULT_NEW_COURSE_ID;
            group.isOptedOut = false;
        }

        group.assignedTasksIds = assignedTasksIds;
        group.isUpdated = isAdd || false;
        group.carryForward = carryForward || false;

        if (classroom.classroomGroups.find(val => !!val.isUpdated)) {
            classroom.isUpdated = true;
        } else {
            classroom.isUpdated = isAdd || false;
        }
        if (!isAdd) {
            this.setState({
                isUpdated: true
            });
        }

        this.disableSave = !this.classrooms.find(val => !!val.isUpdated);
        this.disableAssign();
    }

    saveAssignCourse = () => {
        const classrooms = this.classrooms;
        const changedCourseList = [];
        const updatedClassrooms = filter(classrooms, val => !!val.isUpdated);

        forEach(updatedClassrooms, (classroom) => {
            const updatedGroups = classroom.classroomGroups.filter(val => !!val.isUpdated);

            updatedGroups.forEach((group) => {
                const courseInfo = {};
                courseInfo.classroomId = classroom.classroomId;
                courseInfo.groupId = group.id;
                courseInfo.carryForward = group.carryForward;
                courseInfo.assignedTaskIds = group.assignedTasksIds;

                courseInfo.courseId = group.newCourseId !== undefined ? group.newCourseId : group.courseId;
                courseInfo.upfCourseId = group.upfCourseId;
                courseInfo.isOptedOut = !group.upfCourseId;

                courseInfo.conquestCourseId = group.conquestCourseId;

                changedCourseList.push(courseInfo);
            });
        });

        this.props.handleOnSaveAssignCourses(changedCourseList);
    }

    getFilteredClassroom = (classrooms) => {
        const classId = this.state.selectedClassroom !== -1 ? this.state.selectedClassroom : classrooms[0].classroomId;
        return classrooms.find(item => item.classroomId === classId);
    }

    getSelectedGroupInfo = classroom =>
        (classroom.classroomGroups.find(item => item.id === this.state.selectedGroup));

    updateState = (type, val) => {
        switch (type) {
        case 'year':
            this.setState({ selectedYearGroup: val });
            this.updateClassroomId(val);
            break;
        case 'class':
            this.setState({ selectedClassroom: val });
            this.updateClassroomGroupId(val);
            break;
        case 'group':
            this.setState({ selectedGroup: val });
            break;
        case 'learningModule':
            this.setState({
                ...val,
                selectedCourse: {
                    ...this.state.selectedCourse,
                    legacy: val.LegacySelected === true,
                    UPF: val.UPFSelected,
                    newCourse: val.NewCoursesSelected
                }
            });
            break;
        default:
            break;
        }
    }

    closeModal = (cancelConfirmationModalRequest) => {
        if (cancelConfirmationModalRequest) {
            this.showCancelConfirmation = false;
        }
        this.props.dispatch({ type: actionTypes.DEACTIVATE_MODAL_REQUEST });
    }

    openModal = () => {
        this.props.dispatch({ type: actionTypes.ACTIVATE_MODAL_REQUEST });
    }

    handleTaskCarryForward = (event) => {
        const { assignedTasksId, upfCourseId } = this.props;
        this.props.dispatch({ type: actionTypes.CANCEL_ASSIGN_REQUEST });

        switch (event) {
        case 'handleOnBack':this.disableAssign();
            break;
        case 'handleOnCarryTask':this.addRemoveNewCourse(true, assignedTasksId, true, upfCourseId);
            break;
        case 'handleOnCarryTaskCancel': this.addRemoveNewCourse(true, assignedTasksId, false, upfCourseId);
            break;
        default: break;
        }

        this.closeModal();
    }

    getModalContent = () => {
        const { intl, assignedTasksId, showAssignErrorModal, showSaveErrorModal,
            isAssignEvent, upfCourseId } = this.props;
        let content = null;
        let message = null;
        if (this.showCancelConfirmation) {
            content = (<Confirmation
                handleOnCancel={() => this.closeModal(true)}
                handleOnOk={this.handleOnConfirm}
                icon={Warning}
                title={intl.formatMessage(messages.cancelWarningMessage)} />);
        } else if (!showAssignErrorModal && !showSaveErrorModal) {
            if (assignedTasksId.length > 0) {
                content = (<TaskCarryForward
                    commonTasks={assignedTasksId.length}
                    handleOnBack={() => this.handleTaskCarryForward('handleOnBack')}
                    handleOnCarryTask={() => this.handleTaskCarryForward('handleOnCarryTask')}
                    handleOnCarryTaskCancel={() => this.handleTaskCarryForward('handleOnCarryTaskCancel')} />);
            } else if (isAssignEvent) {
                this.addRemoveNewCourse(true, assignedTasksId, false, upfCourseId);
            }
        } else {
            message = showAssignErrorModal ?
                intl.formatMessage(messages.assignErrorMessage) :
                intl.formatMessage(messages.saveErrorMessage);

            content = (<ConfirmationMessage
                handleOnCloseModal={this.closeModal}
                icon={Warning}
                title={message} />);
        }

        return content;
    }

    handleOnAssign = () => {
        const {
            selectedClassroom,
            selectedGroup,
            selectedCourse,
            UPFSelected,
            LegacySelected,
            NewCoursesSelected
        } = this.state;

        this.props.handleOnAssign({
            classroomId: selectedClassroom,
            groupId: selectedGroup,
            courseId: selectedCourse.id,
            isUPFSelected: UPFSelected,
            isLegacySelected: LegacySelected,
            isNewCoursesSelected: NewCoursesSelected
        });
    }

    handleOnCancel = () => {
        const classrooms = this.classrooms;
        if (!classrooms.find(val => !!val.isUpdated)) {
            PortalCommunication.navigateToLandingScreen('Course admin');
        } else {
            this.showCancelConfirmation = true;
            this.openModal();
        }
    }

    handleOnConfirm = () => {
        this.showCancelConfirmation = false;
        PortalCommunication.navigateToLandingScreen('Course admin');
    }

    disableAssign = () => {
        this.disableAssignToGroup = true;
    }

    shouldShowAssignedCourses = () => {
        const { selectedYearGroup, selectedClassroom, selectedGroup, UPFSelected, LegacySelected, NewCoursesSelected } = this.state;
        return selectedYearGroup !== undefined && selectedYearGroup !== null && selectedClassroom && selectedGroup && (UPFSelected || LegacySelected || NewCoursesSelected);
    }

    shouldShowNewCourses = () => {
        const { selectedYearGroup } = this.state;
        return newCoursesAvailable(selectedYearGroup);
    }

    render() {
        const { intl, activateModal, assigningCourses, handleViewCourse } = this.props;
        return (
            <div>
                <div className={css.panel}>
                    <div className={css.lhsPanel}>
                        <div className={css.header}>
                            <div className={css.yearColumn}>{intl.formatMessage(messages.year)}</div>
                            <div
                                className={css.classColumn}>{intl.formatMessage(messages.class)}</div>
                            <div className={css.groupColumn}>{intl.formatMessage(messages.group)}</div>
                            <div className={css.groupColumn}>{intl.formatMessage(messages.learningModule)}</div>
                            <div className={css.assignedCourseColumn}>{intl.formatMessage(messages.currentCourse)}</div>
                        </div>
                        <div className={css.row}>
                            <div className={css.yearRow}>{this.renderYears()}</div>
                            <div className={css.classRow}>{this.renderYearClassrooms()}</div>
                            <div className={css.groupRow}>{this.renderGroups()}</div>
                            <div className={css.groupRow}>
                                <div
                                    className={css.infoContainer}
                                    onClick={() => this.updateState('learningModule', { LegacySelected: !this.state.LegacySelected, UPFSelected: false, NewCoursesSelected: false })}
                                    role="button"
                                    tabIndex={0}>
                                    <CourseBadge
                                        background={this.state.LegacySelected ? this.activeColor :
                                            this.defaultColor}>
                                        <div className={
                                            this.state.LegacySelected ? `${css.info} ${css.active}`
                                                : `${css.info}`
                                        }>{intl.formatMessage(messages[this.isMathletics ? 'coursesActivityMastery' : 'courses'])}</div>
                                    </CourseBadge>
                                </div>
                                { this.shouldShowNewCourses() && <div
                                    className={css.infoContainer}
                                    onClick={() => this.updateState('learningModule', { NewCoursesSelected: !this.state.NewCoursesSelected, UPFSelected: false, LegacySelected: false })}
                                    role="button"
                                    tabIndex={0}>
                                    <CourseBadge
                                        background={this.state.NewCoursesSelected ? this.activeColor :
                                            this.defaultColor}>
                                        <div className={
                                            this.state.NewCoursesSelected ? `${css.info} ${css.active}`
                                                : `${css.info}`
                                        }>{intl.formatMessage(messages.newCourses)}</div>
                                    </CourseBadge>

                                </div>
                                }
                                { this.isMathletics && <div
                                    className={css.infoContainer}
                                    onClick={() => this.updateState('learningModule', { UPFSelected: !this.state.UPFSelected, LegacySelected: false, NewCoursesSelected: false })}
                                    role="button"
                                    tabIndex={0}>
                                    <CourseBadge
                                        background={this.state.UPFSelected ? this.activeColor :
                                            this.defaultColor}>
                                        <div className={
                                            this.state.UPFSelected ? `${css.info} ${css.active}`
                                                : `${css.info}`
                                        }>{intl.formatMessage(messages.skillQuests)}</div>
                                    </CourseBadge>
                                </div> }


                            </div>
                            <div className={css.courseRow}>{this.renderCourses()}</div>
                        </div>
                    </div>
                    <div className={css.rhsPanel}>{
                        this.shouldShowAssignedCourses() ?
                            <AssignCourses
                                callbackAction={this.disableAssign}
                                handleOnCourseSelection={this.handleOnCourseSelection}
                                handleOnYearGroupSave={this.handleOnAssign}
                                handleViewCourse={handleViewCourse}
                                isLegacySelected={this.state.LegacySelected}
                                isNewCoursesSelected={this.state.NewCoursesSelected}
                                isUPFSelected={this.state.UPFSelected}
                                selectedCourse={this.state.selectedCourse}
                            />
                            : null}
                    </div>
                </div>
                <div className={css.settingsFooter}>
                    <Button
                        containerClassName={css.cancelButton}
                        disabled={assigningCourses}
                        handleOnClick={this.handleOnCancel}
                        label={intl.formatMessage(messages.cancel)}
                    />
                    <Button
                        containerClassName={css.saveButton}
                        disabled={assigningCourses || this.disableSave}
                        handleOnClick={this.saveAssignCourse}
                        label={intl.formatMessage(messages.save)}
                    />
                </div>
                <Modal show={activateModal}>
                    {this.getModalContent()}
                </Modal>
            </div>
        );
    }
}

assignCourseMapper.propTypes = {
    intl: intlShape.isRequired,
    classrooms: PropTypes.arrayOf(PropTypes.object),
    yearGroups: PropTypes.array,
    defaultData: PropTypes.object,
    handleOnAssign: PropTypes.func,
    handleOnSaveAssignCourses: PropTypes.func,
    handleViewCourse: PropTypes.func,
    assignedTasksId: PropTypes.array,
    upfCourseId: PropTypes.number,
    showAssignErrorModal: PropTypes.bool,
    showSaveErrorModal: PropTypes.bool,
    activateModal: PropTypes.bool,
    assigningCourses: PropTypes.bool,
    isAssignEvent: PropTypes.bool,
    dispatch: PropTypes.func.isRequired,
    selectedProduct: PropTypes.object
};

export default injectIntl(styleable(css)(assignCourseMapper));



// WEBPACK FOOTER //
// ./app/components/assign-course-mapper-admin/index.js